import React, { Component } from "react";
import { Link } from "react-router-dom";

import Header from "../component/Header";
import BottomNav from "../component/BottomNav";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import SearchBookList from "../component/SearchBookList";

import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');


//var DEBUG21=true;
var DEBUG21=false;


class Search2 extends Component {
	
	constructor(props) {
        super(props);

        ReactGA.set({ page: window.location.pathname });

		var itms = new Map();
		itms["m_chk1"] = false;
		itms["m_chk2"] = false;
		itms["m_chk3"] = false;
		itms["m_chk4"] = false;
		itms["m_st1"] = false;
		itms["m_st2"] = true;

		var mapst = new Map();
		mapst["m_st1"] = false;
		mapst["m_st2"] = true;

		this.state = {
		    headerTitle: "더책", totalcount: 0, curpageidx: 0, 
		    orderby: 0, orderway: 0, 
			checkedItems: itms,
			st: mapst,
			srch_subject: "",
			srch_author: "",
			srch:"",
			booklist: [], loading: true
		};

		this.handleChange_onCheckBox = this.handleChange_onCheckBox.bind(this);
		this.handleChange_onCheckBox_st = this.handleChange_onCheckBox_st.bind(this);

		this.getData(true);
	}

	handleChange(event) {
		const strinput = event.target.value;

		var query = event.target.value;
		if(DEBUG21) console.log("searchstring: " + query);
		this.state.srch = query;
		this.state.srch_subject = "";
		this.state.srch_author = "";
		this.getData(true);
		query += " ";
		//this.getData(true);
	}

	getData(binit) {
		if(DEBUG21) console.log(binit + ", " + this.state.curpageidx + ", " + this.state.totalcount);

		if (binit === false && this.state.booklist.length >= this.state.totalcount)
			return;
		this.state.loading = true;

		//if(DEBUG21) console.log("aaa: " + strquery + ", " + this.prevState);

		var agelist = '';
		if (this.state.checkedItems['m_chk1'] === true) {
			agelist += "|10|20|";
		}
		if (this.state.checkedItems['m_chk2'] === true) {
			agelist += "|30|40|";
		}
		if (this.state.checkedItems['m_chk3'] === true) {
			agelist += "|50|60|";
		}
		if (this.state.checkedItems['m_chk4'] === true) {
			agelist += "|70|";
		}

		var st = 0;
		if (this.state.st["m_st1"] === true && this.state.st["m_st2"] === true) {
		    st = 50;
		}
		else if (this.state.st["m_st1"] === true) {
		    st = 40;
		}
		else if (this.state.st["m_st2"] === true) {
		    st = 20;
		};
		st= 20; //LSB

		if (binit === true) {
		    this.state.curpageidx = 0;
		};

		var this_orderby= this.state.orderby;
		if(this.state.srch==="" && this.state.srch_subject==="" && this.state.srch_author==="") {
		    this_orderby=100; //random order
		}

        let qtm= (new Date()).getTime();
        let url1= `/api/AB/BookListR2?pgidx=${this.state.curpageidx}&pgsize=50`;
            url1=url1+`&orderby=${this_orderby}&orderway=${this.state.orderway}`;
            url1=url1+`&search=${this.state.srch}&srch_subject=${this.state.srch_subject}&srch_author=${this.state.srch_author}`;
            url1=url1+`&agelist=${agelist}&servicetype=${st}&qrtime=${qtm}`;
		if(DEBUG21) console.log("search url "+url1);
		if(DEBUG21) console.dir(this.state);

		fetch(url1)
			.then(response => response.json())
			.then(data => {

				this.state.loading = false;
			    //alert(JSON.stringify(data));
				if(DEBUG21) console.dir(data);
				if(DEBUG21) console.log(data.strSQL);

				if (binit === true) {
					this.state.curpageidx = 0;
					this.state.booklist = data.lstresult;
					this.state.curpageidx++;
				}
				else {
					this.state.curpageidx++;
					this.state.booklist.push(...data.lstresult);
				}
				
				//const booklist = data.lstresult;

				this.setState({ totalcount: data.totalcount, curpageidx: this.state.curpageidx, booklist: this.state.booklist, loading: false });
				//this.render();
            });

        if (this.state.srch.length > 0)
            this.logSearchKeyword("검색",this.state.srch);

        if (this.state.srch_author.length > 0)
            this.logSearchKeyword("저자검색", this.state.srch_author);

        if (this.state.srch_subject.length > 0)
            this.logSearchKeyword("제목검색", this.state.srch_subject);

	};

	componentWillMount() {
		var self = this;
		window.addEventListener('scroll', function () {
			if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
				if(DEBUG21) console.log("you're at the bottom of the page");
				if (self.state.loading === false) {
					self.getData(false);
				}
			}
		});
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll, true);
	}

	handleChange_onCheckBox(e) {
		const item = e.target.name;
		const isChecked = e.target.checked;
		if(DEBUG21) console.log("item: " + e.target.name + ", checked: " + isChecked);
		this.state.checkedItems[item] = isChecked;

		//if(DEBUG21) console.log(JSON.stringify(this.state.checkedItems));
		//if(DEBUG21) console.log(JSON.stringify(this.state));

		var agelist = '';
		if (this.state.checkedItems['m_chk1'] === true) {
			agelist += "|10|20|";
		}
		if (this.state.checkedItems['m_chk2'] === true) {
			agelist += "|30|40|";
		}
		if (this.state.checkedItems['m_chk3'] === true) {
			agelist += "|50|60|";
		}
		if (this.state.checkedItems['m_chk4'] === true) {
			agelist += "|70|";
		}
		if(DEBUG21) console.log('ages: ' + agelist);

		//var self = this.state.self;
		//self.dofetchdata(agelist, true);
	}

	handleChange_onCheckBox_st(e) {
		const item = e.target.name;
		const isChecked = e.target.checked;
		if(DEBUG21) console.log("item: " + e.target.name + ", checked: " + isChecked);
		this.state.st[item] = isChecked;
	}

	handleChange_subject(event) {
		const strinput = event.target.value;
		var query = event.target.value;
		this.state.srch_subject = query;
		this.state.srch="";
		if(DEBUG21) console.log("srch_subject: " + query);
	}

	handleChange_author(event) {
		const strinput = event.target.value;
		var query = event.target.value;
		this.state.srch_author = query;
		this.state.srch="";
		if(DEBUG21) console.log("srch_subject: " + query);
	}

	dosearch() {
		//alert(JSON.stringify(this.state));
		this.getData(true);
	}

    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    logSearchKeyword( target, searchkeyword) {
        ReactGA.event({
            category: target,
            action: searchkeyword
        });
    }
    
    handleExpChange = panelname => (event, expanded) => {
        //console.log("hExpC ");
        //console.log(panelname);
        //console.log(event);
        //console.log(expanded);
        if(expanded===true) {
            window.scrollTo(0, 200);
        } else {
            window.scrollTo(0, 0);
        }
    }

    render() {
        this.logPageView();

		//let contents = this.state.loading === true ? "loading..." : this.dorender();
		let contents = "loading...";

		return (
			<React.Fragment>
				<Header headerTitle={this.state.headerTitle} />

               <div >
                <div ref="toptitle"  style={{marginBottom: '-10px'}} >
                <br/><p/>
                <center>
							<div class="subtitle"><h3> 도서 검색   </h3></div>
                </center>
                </div>


              <div classNamme="section-body">
				<div className="searchBar">
					<input className="form-input" placeholder="검색어를 입력해 주세요" type="text" onChange={this.handleChange.bind(this)} />
				</div>

				<div className="searchFilter" >
					<ExpansionPanel elevation={0} onChange={this.handleExpChange("panel1")} >
						<ExpansionPanelSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel1a-content"
							id="panel1a-header"
						>
							상세검색
						</ExpansionPanelSummary>
						<ExpansionPanelDetails>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<div className="form-group">
										<input className="form-input" onChange={this.handleChange_subject.bind(this)} placeholder="제목" type="text" />
									</div>
									<div className="form-group">
										<input className="form-input" onChange={this.handleChange_author.bind(this)} placeholder="저자" type="text" />
									</div>
								</Grid>
   <Grid item xs={12}>
       <table width="100%">
       <tr>
           <td width='80px'><h4> 음원 타입</h4></td>
           <td>
           <FormGroup row>
               <FormControlLabel
                    control={<Checkbox value="audiobook" name="m_st1" onChange={this.handleChange_onCheckBox_st} color="primary"  checked={this.state.st['m_st1']} />}
                   label="오디오북"
               />
               <FormControlLabel
                   control={<Checkbox value="ebook" name="m_st2" onChange={this.handleChange_onCheckBox_st} color="primary"   checked={this.state.st['m_st2']} />}
                   label="전자책"
               />
           </FormGroup>
           </td>
       </tr>
       </table>
       <table width="100%">
       <tr>
           <td width='80px'><h4> 도서 분류</h4></td>
           <td>
           <select id="bookcate" name="bookcate" className="form-select">
               <option value="">전체</option>
           </select>
           </td>
       </tr>
       </table>
       <table width="100%">
       <tr>
           <td width="80px"> <h4> 대상 연령 </h4> </td>
           <td>
           <FormGroup row>
               <FormControlLabel
                   control={<Checkbox value="10|20" color="primary" name="m_chk1" onChange={this.handleChange_onCheckBox} checked={this.state.checkedItems['m_chk1']} />}
                   label="영유아"
               />
               <FormControlLabel
                   control={<Checkbox value="40|50" color="primary" name="m_chk2" onChange={this.handleChange_onCheckBox} checked={this.state.checkedItems['m_chk2']} />}
                   label="초등"
               />
               <FormControlLabel
                   control={<Checkbox value="60|70" color="primary" name="m_chk3" onChange={this.handleChange_onCheckBox} checked={this.state.checkedItems['m_chk3']} />}
                   label="중/고등"
               />
               <FormControlLabel
                   control={<Checkbox value="80" color="primary" name="m_chk4" onChange={this.handleChange_onCheckBox} checked={this.state.checkedItems['m_chk4']} />}
                   label="성인"
               />
           </FormGroup>
           </td>
       </tr>
       </table>
       <div className="form-group">
           <Button variant="contained" fullWidth="true" className="btn btn-primary" onClick={this.dosearch.bind(this)} >
               <SearchOutlinedIcon />
               검색
           </Button>
       </div>
   </Grid>
</Grid>
</ExpansionPanelDetails>
</ExpansionPanel>
</div>
	
<div className="section-body">
    <React.Fragment>
        <ul className="bookList">
            {this.state.booklist.map((book, index) => {
                return (
                    <React.Fragment>
                        <li className="bookList-item">
                            <Link to={`/book/${book.id}`}>
                                <div className="bookList-thumbnail">
                                    <div className="thumbnail">
                                        <img
                                            className="thumbnail-image"
                                            src={`/api/AB/GetCoverImage?thumb=2&imgid=${book.id}`}
                                            alt={book.subject}
                                        />
                                    </div>
                                </div>
                                <div className="bookList-info">
                                    <h3 className="bookList-title">{book.subject}</h3>
                                    <h4 className="bookList-author">작가: {book.author_name}</h4>
                                    <h4 className="bookList-publisher">출판사: {book.publisher_name}</h4>
                                </div>
                            </Link>
                        </li>
                    </React.Fragment>
                );
                            })}
        </ul>
    </React.Fragment>
					
</div>
</div>
</div>
<BottomNav />
</React.Fragment>
);
                            }
                            }

export default Search2;
